import React, { useState, useEffect, useRef } from "react";
import { MapPin, Loader2 } from "lucide-react";
import api from "../lib/api";

const inputCls = "w-full rounded-xl bg-[#0C0A0A]/60 border border-[#D4AF37]/20 focus:border-[#D4AF37]/60 outline-none px-3 py-2.5 text-sm text-[#FBF8F3] placeholder:text-[#9E978E]";

export default function CityAutocomplete({ value, onSelect, placeholder = "Search city…", testid = "city-autocomplete" }) {
  const [q, setQ] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const boxRef = useRef();
  const debRef = useRef();

  useEffect(() => { setQ(value || ""); }, [value]);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const onChange = (e) => {
    const val = e.target.value;
    setQ(val);
    clearTimeout(debRef.current);
    if (val.trim().length < 2) { setResults([]); setOpen(false); return; }
    debRef.current = setTimeout(async () => {
      setBusy(true);
      try {
        const { data } = await api.get("/locations/search", { params: { q: val.trim() } });
        setResults(data.results || []);
        setOpen(true);
      } catch (e) { setResults([]); } finally { setBusy(false); }
    }, 350);
  };

  const pick = (r) => {
    setQ(r.label);
    setOpen(false);
    onSelect(r);
  };

  return (
    <div className="relative" ref={boxRef}>
      <MapPin size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9E978E]" />
      <input data-testid={testid} value={q} onChange={onChange} onFocus={() => results.length && setOpen(true)}
        placeholder={placeholder} className={inputCls + " pl-9"} autoComplete="off" />
      {busy && <Loader2 size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#D4AF37] animate-spin" />}
      {open && results.length > 0 && (
        <div data-testid={`${testid}-dropdown`} className="absolute z-50 mt-1 w-full db-glass rounded-xl border border-[#D4AF37]/25 max-h-60 overflow-y-auto">
          {results.map((r, i) => (
            <button key={i} type="button" data-testid={`${testid}-option-${i}`} onClick={() => pick(r)}
              className="w-full text-left px-3 py-2.5 text-sm text-[#D8D2C9] hover:bg-[#541224]/40 hover:text-[#FBF8F3] flex items-center gap-2 border-b border-white/5 last:border-0">
              <MapPin size={13} className="text-[#D4AF37] shrink-0" /> {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
